
import { CustomAppLayout } from '../../../layout';
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Checkbox, FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../../commons/functions';

export const MembersEtcDownloads = () => {
    const { data, menu, parameters } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const options = [
        { text: 'Movimientos', value: 'movements', description: 'Registro de todos los movimientos de su cuenta club. No incluye cuenta casino' },
        { text: 'Bitácoras', value: 'flights', description: 'Histórico de bitácoras de aeronaves club o planeadores privados' },
        { text: 'Reservas', value: 'bookings', description: 'Histórico de todas las reservas realizadas, se incluyen las eliminadas' },
        { text: 'Chequeos', value: 'checks', description: 'Chequeos realizados en todos sus estados' }
    ]

    const handleGetUser = async () => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.period) {

            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/profile/download',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        attributes: selectedOptions,

                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    const exportToExcel = () => {
                        const wb = XLSX.utils.book_new();
                        const reports = dataWeb.report;
                        Object.entries(reports).forEach(([key, value]: [string, any]) => {
                            const matchedOption = options.find(opt => opt.value === key);
                            const sheetName = matchedOption ? matchedOption.text : key;
                            const ws = XLSX.utils.json_to_sheet(value || []);
                            XLSX.utils.book_append_sheet(wb, ws, sheetName);
                        });
                        XLSX.writeFile(wb, `${parameters.idUser}-${getUser(parameters.idUser, data).displayName}.xlsx`);
                    };
                    exportToExcel();
                    setSelectedOptions([]);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}
                        description="Excel con tablas históricas según parametros de selección"
                    >Ficha de usuario</Header>
                    <SpaceBetween size="s" direction="vertical">

                        <FormField label="Atributos">
                            <SpaceBetween size="l" direction="vertical">
                                {options.map((option) => (
                                    <FormField label={
                                        <Checkbox key={option.value} checked={selectedOptions.includes(option.value)} onChange={({ detail }) => {
                                            const newSelectedOptions = detail.checked ? [...selectedOptions, option.value] : selectedOptions.filter((value) => value !== option.value);
                                            setSelectedOptions(newSelectedOptions);
                                        }}>
                                            <strong>{option.text}</strong>
                                        </Checkbox>
                                    }
                                    >{option.description}
                                    </FormField>
                                ))}
                            </SpaceBetween>
                        </FormField>
                        <Box float="right">
                            <Button
                                disabled={selectedOptions.length === 0}
                                variant="primary" onClick={() => {
                                    handleGetUser();
                                }}>Generar</Button>
                        </Box>
                    </SpaceBetween>

                </SpaceBetween>
            }
        />
    )
};
